import Vue from 'vue';
import store from './../../store';
import billTypeTransformer from './../../transformers/billType';

const success = ({ data }, resolve) => {
  const billTypes = billTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchBillTypes', billTypes);
  resolve();
};

const failed = () => {
};

// Display bill types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('bill_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/billType/all.js